module.exports = __webpack_public_path__ + "static/media/atc_ultima_1.71762fa2.webp";